import React from "react";

import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FilterListIcon from "@material-ui/icons/FilterList";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 40,
    borderRadius: theme.shape.borderRadius,
    whiteSpace: "nowrap",
    flexShrink: 0,
    [theme.breakpoints.down("xs")]: {
      minWidth: 44,
      paddingLeft: theme.spacing(1.25),
      paddingRight: theme.spacing(1.25),
    },
  },
  label: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
}));

const FilterButton = ({
  count = 0,
  open = false,
  label = "Filtros",
  controls,
  className = "",
  onClick,
  ...buttonProps
}) => {
  const classes = useStyles();
  const activeCount = Number(count) || 0;
  const accessibleLabel =
    activeCount > 0 ? `${label}, ${activeCount} ativos` : label;

  return (
    <Button
      {...buttonProps}
      className={`${classes.root} ${className}`.trim()}
      variant={open || activeCount > 0 ? "contained" : "outlined"}
      color="primary"
      startIcon={<FilterListIcon />}
      aria-label={accessibleLabel}
      aria-haspopup="dialog"
      aria-expanded={open}
      aria-controls={open ? controls : undefined}
      onClick={onClick}
    >
      <span className={classes.label}>
        {label}
        {activeCount > 0 ? ` (${activeCount})` : ""}
      </span>
    </Button>
  );
};

export default FilterButton;
